import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RateTypeModel} from '../../../../models/RateTypeModel';
import {RateTypeAnagrafService} from '../../../general-services/service-rate-type/rate-type-anagraf.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-edit-rate-type-anagraf',
  templateUrl: './edit-rate-type-anagraf.component.html',
  styleUrls: ['./edit-rate-type-anagraf.component.scss']
})
export class EditRateTypeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  rateType: RateTypeModel;
  registerForm: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  rateTypeCod: string;
  description: string;
  rateTypefJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private rateTypeAnagrafService: RateTypeAnagrafService, private _activatedRoute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.rateTypefJson = params['row'];
      });

    this.rateType = new RateTypeModel();

    this.formBuilder = new FormBuilder();

    this.registerForm = this.formBuilder.group({
      code: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.rateType = JSON.parse(this.rateTypefJson) as RateTypeModel;

    this.registerForm.patchValue({
      code: this.rateType ? this.rateType.code : ''
    });

    this.registerForm.patchValue({
      description: this.rateType ? this.rateType.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.rateTypeCod = params['code'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RATE_TYPE__ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.rateType.code = this.registerForm.controls['code'].value;
      this.rateType.description = this.registerForm.controls['description'].value;
      this.saveSubscribe = this.rateTypeAnagrafService.update(this.rateTypeAnagrafService.baseUrl, this.rateType).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Rate Type Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Site with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RATE_TYPE__ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}

